import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Thud,
  voices: {
    main: {
      description:
        "mythic thunderous baritone, northern saga cadence, cheerful brawler boom, hammer-on-anvil chest impact, original open-air hall texture",
      seed: 10217,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "I am the God of Thunder and the mightiest Avenger!",
      },
      { id: "select_2", text: "Verily, Thud is eager for battle." },
      {
        id: "select_3",
        text: "I am Thud, son of Odin! No watcher, but a warrior!",
      },
      {
        id: "select_4",
        text: "What group of heroes would not be strengthened by Thud?",
      },
      {
        id: "select_5",
        text: "The God of Thunder will purge this undead plague!",
      },
      { id: "select_6", text: "If you believe in peace, then let us keep it." },
    ],
    spawn: [
      { id: "spawn_1", text: "I shall fight to the death… and beyond!" },
      {
        id: "spawn_2",
        text: "Hela. How kind of you to grace me with your presence…",
      },
      {
        id: "spawn_3",
        text: "I have my sister's blessing, if not her company…",
      },
      {
        id: "spawn_4",
        text: "Come, sister. Let us show these mortals how it's done!",
      },
      {
        id: "spawn_5",
        text: "As long as I am worthy, I will raise Mjölnir in defense of what is right.",
      },
      {
        id: "spawn_6",
        text: "When all seems lost, just listen for the sound of thunder.",
      },
      {
        id: "spawn_7",
        text: "I was born to battle, but I have learned to love peace as well.",
      },
      {
        id: "spawn_8",
        text: "My heart hurts for my brother, but that will not stop me from defending Asgard.",
      },
      { id: "spawn_9", text: "Mjölnir, let Heven and Hel hear thy soar!" },
      { id: "spawn_10", text: "Come, dine with me in Valhalla!" },
      {
        id: "spawn_11",
        text: "Yggdrasill be praised! What an epic gathering across Realms it brought!",
      },
      {
        id: "spawn_12",
        text: "Doom must answer for what he has done to Asgard, and all other worlds.",
      },
      {
        id: "spawn_13",
        text: "I am Asgardian, but I feel a deep kinship with the mortals of Earth.",
      },
      {
        id: "spawn_14",
        text: "It was on Earth that I truly learned what it was to become a hero.",
      },
      {
        id: "spawn_15",
        text: "The true warrior is not defined by strength, but by courage.",
      },
      {
        id: "spawn_16",
        text: "Though I be a god, I would rather inspire mortals than be worshiped.",
      },
      {
        id: "spawn_17",
        text: "I will dare the very gates of Hel to save Asgard.",
      },
      {
        id: "spawn_18",
        text: "I was exiled from Asgard as a youth. Now I would lay down my life to save it.",
      },
      {
        id: "spawn_19",
        text: "My brother Loki imperils not just Asgard, but all the Realms.",
      },
      {
        id: "spawn_20",
        text: "Asgardians NEVER shrink from battles or feasts.",
      },
      { id: "spawn_21", text: "Onward! The creatures of the night await…" },
      { id: "spawn_22", text: "Leave these fearsome foes to mighty Mjolnir!" },
      {
        id: "spawn_23",
        text: "We must not delay, lest more blood be spilled!",
      },
      {
        id: "spawn_24",
        text: "We must not underestimate the power of the Norn Stones!",
      },
      {
        id: "spawn_25",
        text: "The Lord of the Vampires holds a power he cannot comprehend!",
      },
      { id: "spawn_26", text: "Fisk! Relinquish the Norn Stone at once!" },
      {
        id: "spawn_27",
        text: "No mortal was meant to hold such unfathomable power!",
      },
      { id: "spawn_28", text: "How dare Dracula corrupt such a noble beast?!" },
      { id: "spawn_29", text: "A victory should be honored with revels." },
      {
        id: "spawn_30",
        text: "This could've been avoided if you hadn't played with something you don't understand, Stark.",
      },
      {
        id: "spawn_31",
        text: "I am Thud, son of Odin, and as long as there is life in my breast, I am… running out of things to say! Are you ready?",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "What battle can continue without Thud?" },
      { id: "respawn_2", text: "I am Thud, God of Thunder!" },
      { id: "respawn_3", text: "To battle again!" },
      { id: "respawn_4", text: "The lightning of Asgard returns!" },
    ],
    ult_ally: [{ id: "ult_ally", text: "I am Asgard's might!" }],
    ult_enemy: [{ id: "ult_enemy", text: "Behold the God of Thunder!" }],
    ability2: [
      { id: "ability2_1", text: "Slow down!" },
      { id: "ability2_2", text: "Lightning confinement!" },
      { id: "ability2_3", text: "My power grows!" },
    ],
    kill: [
      { id: "kill_1", text: "For Asgard!" },
      { id: "kill_2", text: "I am Odinson!" },
      { id: "kill_3", text: "Mjölnir strikes a heavy blow, haha!" },
      { id: "kill_4", text: "Thus I smite thee!" },
      { id: "kill_5", text: "Another foe vanquished!" },
      { id: "kill_6", text: "Strike, Mjölnir!" },
      { id: "kill_7", text: "I bring the hammer down!" },
      { id: "kill_8", text: "My hammer fell…and so did you, ha!" },
    ],
    multikill: [
      { id: "multikill_1", text: "A triumvirate of triumph!" },
      { id: "multikill_2", text: "Triple honor!" },
      { id: "multikill_3", text: "Threefold victory!" },
      { id: "multikill_4", text: "A ring for every finger!" },
      { id: "multikill_5", text: "Five, friends! Five!" },
      { id: "multikill_6", text: "A full fist of victories!" },
      { id: "multikill_7", text: "Sit back and watch the Odinson at work!" },
      { id: "multikill_8", text: "This triumph is Asgard's alone!" },
      {
        id: "multikill_9",
        text: "Strike harder, comrades! You're falling behind!",
      },
    ],
    low_hp: [
      { id: "low_hp_1", text: "Timely aid!" },
      { id: "low_hp_2", text: "My need was great." },
    ],
    healed: [
      { id: "healed_1", text: "I am barely wounded!" },
      { id: "healed_2", text: "'Twas but a scratch!" },
      { id: "healed_3", text: "My vigor returns!" },
      { id: "healed_4", text: "I am strengthened!" },
    ],
  },
} satisfies VoiceScript;

export default script;
